<template>
    <div>
        <v-card flat class="pa-8">
            <v-row dense>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3" class="mr-2">
                    <v-btn
                        depressed
                        dark
                        color="blue-grey darken-1"
                        @click="editContext('texts', 'Textos de alertas')"
                        :class="$css_button"
                        block
                    >
                        Textos de alertas
                    </v-btn>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3"  class="mr-2">
                
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3" class="mr-2">
                    
                </v-col>  
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3" class="mr-2">
                    
                </v-col>    
            </v-row>
        </v-card>

        <!-- contexto  -->
        <v-dialog
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-system-bar
                dark
                color="primary"
                height="10px"
            >    
            </v-system-bar>    

            <v-card
                class="pa-2"
            >
                <v-card-title class="text-h5">
                    {{ title }}

                    <v-spacer></v-spacer>
                    <v-btn icon @click="openCloseDialog()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>
            
                <v-container fluid>
                    <v-row>
                        <v-col cols="12">
                            <text-component v-if="context == 'texts'" :object="texts" @callLoadItem="loadTexts"></text-component>
                        </v-col>
                    </v-row>     
                </v-container>
            </v-card>
        </v-dialog>
        <!-- fim contexto  -->
    </div>
</template>

<script>
import TextComponent from '@/components/text/TextComponent.vue'

export default {
    components: {
       TextComponent
    },

    created() {
        this.loadTexts()
    },

    computed: {
        me () {
          return this.$store.state.auth.me
        },
    },

    data() {
        return {
            title: '',    
            context: '',
            dialog: false,

            text_params: {
                types: ['Mensalidade em aberto','Contrato a vencer'] 
            },

            texts: {
                model: 'branches',
                item_id: '',
                items: '',
                types: ['Mensalidade em aberto','Contrato a vencer'],
                var_maps: ['nome_locatario','endereco_imovel','lista_mensalidade']
            },


        }
    },

    methods: {
        openCloseDialog(){
            this.dialog = !this.dialog

            if(!this.dialog) this.context = ''
        },

        editContext(context, title){
            this.title = title
            this.context = context
            this.dialog = true
        },

        loadTexts(){
            this.$store.dispatch('loadPromisseTexts', this.text_params)
                        .then(response => {
                            this.texts.items = response.data 
                            this.texts.item_id = this.me.branch_id
                        })
                        .catch(error => {
                            console.log(error)
                        })
        }
    }
}
</script>